<template>
    <span :class="className" @click="handleClick">
        <slot/>
    </span>
</template>

<script>
    export default {
        name: "BlogpostTag",
        props: {
            id: {
                type: String,
                default: ''
            },
            active: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            className() {
                const {active} = this
                return {
                    'blogpost-tag': true,
                    'active': active
                }
            }
        },
        methods: {
            handleClick() {
                const {id} = this
                this.$router.push({
                    name: 'timeline',
                    query: {
                        tag: id
                    }
                })
            }
        }
    }
</script>

<style lang="scss">
    @import "@assets/styles/varibles.scss";
    @import "@assets/styles/mixins.scss";

    .blogpost-tag {
        display: inline-block;
        padding: $paddingSM $paddingBase;
        margin: 0 $paddingBase $paddingBase 0;

        font-size: $fontSizeSM;
        border: 1px solid $borderColor;
        border-color: var(--borderColor);
        border-radius: 9999px;
        cursor: pointer;
        color: $textColor;
        color: var(--textColor);
        @include transition-colors;

        &.active {
            color: $primaryColor;
            color: var(--primaryColor);
            border-color: $primaryColor;
            border-color: var(--primaryColor);
        }
    }
</style>